<template>
  <div class="d-flex gap-2">
    <McCheckbox
      :id="id"
      :disabled="disabled"
      :modelValue="modelValue"
      @change="$emit('update:modelValue', $event)"
    />
    <label :for="id" class="m-0">{{ label }}</label>
    <i
      :id="`${id}-tooltip`"
      class="float-end input-tooltip-btn"
      :class="{
        'icon-outline_info': !isHover,
        'icon-fill_info': isHover,
      }"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    ></i>

    <b-tooltip :target="`${id}-tooltip`" triggers="hover" placement="right">
      {{ tooltip }}
    </b-tooltip>
  </div>
</template>

<script>
import McCheckbox from '@/components/McCheckbox'

export default {
  components: {
    McCheckbox,
  },
  props: {
    modelValue: {},
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isHover: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.input-tooltip-btn {
  padding-top: 3px;
}
</style>
